import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-migration',
  templateUrl: './application-migration.component.html',
  styleUrls: ['./application-migration.component.scss']
})
export class ApplicationMigrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
